export const MAX_PASSWORD_LENGTH = 64;
export const PASSWORD_REQUIREMENT_TEXT =
  `Use 8 to ${MAX_PASSWORD_LENGTH} characters, including an uppercase letter, a lowercase letter, a number, and a special character.`;

export interface PasswordRequirement {
  key: "length" | "uppercase" | "lowercase" | "number" | "special";
  label: string;
  met: boolean;
}

export function getPasswordRequirements(password: string): PasswordRequirement[] {
  return [
    { key: "length", label: `8 to ${MAX_PASSWORD_LENGTH} characters`, met: password.length >= 8 && password.length <= MAX_PASSWORD_LENGTH },
    { key: "uppercase", label: "An uppercase letter", met: /[A-Z]/.test(password) },
    { key: "lowercase", label: "A lowercase letter", met: /[a-z]/.test(password) },
    { key: "number", label: "A number", met: /\d/.test(password) },
    { key: "special", label: "A special character", met: /[^A-Za-z0-9\s]/.test(password) },
  ];
}

export function isStrongPassword(password: string) {
  return getPasswordRequirements(password).every((requirement) => requirement.met);
}